import React, { useState, useEffect } from 'react';
import { get, api, getBranchOwner } from "@config"
import { notification } from 'antd'
import { CardList, CardListItem, CardListItemHeader, DesktopOnly, MobileOnly } from '../../emit/components/styles';

export default function ActivityList() {
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(false);

    const getActivities = () => {
        setLoading(true);
        const branch = getBranchOwner();
        const url = `${api.branches}${branch.id}/get-secondary-cnae/`;
        
        get(url, (data) => {
            const uniqueActivities = [];
            const seenCodes = new Set();
            for (const act of data) {
                if (!seenCodes.has(act.value)) {
                    seenCodes.add(act.value);
                    uniqueActivities.push(act);
                }
            }
            setActivities(uniqueActivities);
            setLoading(false);
        }, () => setLoading(false));
    };

    const loadActivities = () => {
        setLoading(true);
        const branch = getBranchOwner();
        const url = `${api.branches}${branch.id}/load-activities/`;
        
        get(url, () => {
            notification.open({
                message: 'Atividades atualizadas!',
                type: 'success',
                duration: 2
            });
            getActivities();
        }, (error) => {
            let desc = 'Ocorreu um erro desconhecido na comunicação.';
            if (error && error.response) {
                try {
                    let resp = JSON.parse(error.response);
                    let errorData = resp.error || resp;
                    desc = errorData.description || errorData.message || (typeof errorData === 'string' ? errorData : desc);
                } catch (e) { }
            } else if (error && error.description) {
                desc = error.description;
            } else if (error && error.message) {
                desc = error.message;
            } else if (typeof error === 'string') {
                desc = error;
            }
            
            notification.open({
                message: 'Erro ao carregar atividades',
                description: desc,
                type: 'error',
                duration: 6
            });
            setLoading(false);
        });
    };

    useEffect(() => {
        getActivities();
    }, []);

    return (
        <div style={{ marginTop: '40px', borderTop: '1px solid #EAECF0', paddingTop: '32px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <div>
                    <h3 style={{ margin: 0, fontWeight: 700, fontSize: '1.25rem', color: '#101828' }}>
                        <i className="fas fa-tasks me-2 text-info" style={{ color: '#0088cc' }}></i> Atividades de Serviço (CNAE)
                    </h3>
                    <p style={{ color: '#667085', fontSize: '0.9rem', margin: 0 }}>Sincronize os CNAEs secundários do seu CNPJ para emissão de nota.</p>
                </div>
                <button
                    className="btn btn-outline-info btn-sm"
                    onClick={loadActivities}
                    disabled={loading}
                    style={{ borderRadius: '8px', padding: '8px 16px', fontWeight: 600, borderColor: '#0088cc', color: '#0088cc' }}
                >
                    <i className={`fas ${loading ? 'fa-circle-notch fa-spin' : 'fa-sync-alt'} me-2`}></i>
                    {loading ? 'Sincronizando...' : 'Sincronizar CNPJ'}
                </button>
            </div>

            <DesktopOnly>
                <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #EAECF0', overflow: 'hidden' }}>
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead style={{ background: '#F9FAFB' }}>
                                <tr>
                                    <th style={{ padding: '12px 20px', fontSize: '0.75rem', fontWeight: 600, color: '#475467', textTransform: 'uppercase', borderBottom: '1px solid #EAECF0' }}>Código</th>
                                    <th style={{ padding: '12px 20px', fontSize: '0.75rem', fontWeight: 600, color: '#475467', textTransform: 'uppercase', borderBottom: '1px solid #EAECF0' }}>Descrição da Atividade</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activities.map((activity, index) => (
                                    <tr key={index}>
                                        <td style={{ padding: '12px 20px', verticalAlign: 'middle' }}>
                                            <span style={{ background: '#F2F4F7', color: '#344054', padding: '4px 8px', borderRadius: '6px', fontSize: '0.85rem', fontWeight: 600 }}>
                                                {activity.value}
                                            </span>
                                        </td>
                                        <td style={{ padding: '12px 20px', verticalAlign: 'middle', color: '#475467', fontWeight: 500 }}>
                                            {activity.label}
                                        </td>
                                    </tr>
                                ))}
                                {activities.length === 0 && !loading && (
                                    <tr>
                                        <td colSpan="2" style={{ padding: '40px', textAlign: 'center', color: '#667085' }}>
                                            <i className="fas fa-info-circle d-block mb-2" style={{ fontSize: '1.5rem', opacity: 0.5 }}></i>
                                            Nenhuma atividade encontrada. Clique em sincronizar.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </DesktopOnly>
            <MobileOnly>
                {activities.length === 0 && !loading ? (
                    <CardList>
                        <CardListItem>
                            <CardListItemHeader>
                                <div>
                                    <strong style={{ color: '#101828' }}>Nenhuma atividade</strong>
                                    <span style={{ color: '#667085', fontSize: '0.9rem' }}>Sincronize para ver seus CNAEs.</span>
                                </div>
                            </CardListItemHeader>
                        </CardListItem>
                    </CardList>
                ) : (
                    <CardList>
                        {activities.map((activity, index) => (
                            <CardListItem key={index}>
                                <CardListItemHeader>
                                    <div>
                                        <span style={{ fontSize: '0.8rem', color: '#667085', textTransform: 'uppercase', fontWeight: 600 }}>Código</span>
                                        <strong style={{ color: '#101828' }}>{activity.value}</strong>
                                    </div>
                                </CardListItemHeader>
                                <p style={{ margin: 0, color: '#475467' }}>{activity.label}</p>
                            </CardListItem>
                        ))}
                    </CardList>
                )}
            </MobileOnly>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/config/components/ActivityList.jsx